import * as settingsActions from "../settings/actions";
import * as authActions from "../auth/actions";
import * as usersActions from "../users/actions";
import { Map } from "immutable";
import { bindActionCreators } from "redux";
import * as menuActions from "../menu/actions";
import * as fieldsActions from "../fields/actions";
import * as pageActions from "../pages/actions";
import * as pagesTranslationsActions from "../pageTranslations/actions";
import * as templatesActions from "../templates/actions";
import * as auditsActions from "../audits/actions";
import * as categoriesActions from "../categories/actions";
import * as categoriesTranslationsActions
  from "../categoriesTranslations/actions";
import * as fieldCategoriesActions from "../fieldCategories/actions";
import * as fieldCategoriesTranslationsActions
  from "../fieldCategoriesTranslations/actions";
import * as localeActions from "../locales/actions";
import * as filesActions from "../files/actions";
import * as localesActions from "../locales/actions";
import * as mediaActions from "../media/actions";
import * as mediaCategoriesActions from "../mediaCategories/actions";
import * as menuItemsActions from "../menuItems/actions";
import * as menusActions from "../menus/actions";
import * as menuTranslationsActions from "../menuTranslations/actions";
import * as notificationsActions from "../notifications/actions";
import * as pagesListsActions from "../pagesLists/actions";
import * as settingsApiActions from "../settingsApi/actions";
import * as userGroupsActions from "../userGroups/actions";
import * as sectionsActions from "../sections/actions";
import * as galleriesActions from "../galleries/actions";
import * as galleryItemsActions from "../galleryItems/actions";
import * as ordersActions from "../orders/actions";
import * as formSubmissionsActions from "../formSubmissions/actions";
// import { ActionCreators } from 'redux-undo';

const actions = [
  settingsActions,
  authActions,
  usersActions,
  menuActions,
  fieldsActions,
  pageActions,
  pagesTranslationsActions,
  templatesActions,
  auditsActions,
  categoriesActions,
  categoriesTranslationsActions,
  fieldCategoriesActions,
  fieldCategoriesTranslationsActions,
  localeActions,
  filesActions,
  localesActions,
  mediaActions,
  mediaCategoriesActions,
  menuItemsActions,
  menusActions,
  menuTranslationsActions,
  notificationsActions,
  pagesListsActions,
  settingsApiActions,
  userGroupsActions,
  sectionsActions,
  galleriesActions,
  galleryItemsActions,
  ordersActions,
  formSubmissionsActions
  // ActionCreators
];

export default function mapDispatchToProps(dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === "function")
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch)
  };
}



// WEBPACK FOOTER //
// ./src/common/app/mapDispatchToProps.js